import { Group } from "../../../ducks/group";
import { PlusIcon } from "../../atoms/icons/PlusIcon";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { useGroups } from "./hook";

export const GroupsPage: React.FC = () => {
  const {
    canCreate,
    canEdit,
    groups,
    tableHeaders,
    fetchGroups,
    handleRegistration,
    handleEdit,
  } = useGroups();

  return (
    <MainTemplate
      title="グループ一覧"
      number={groups ? `（${groups.length}件）` : ""}
      button={
        canCreate
          ? {
              text: "新規グループ登録",
              variant: "filled",
              onClick: handleRegistration,
              icon: PlusIcon,
            }
          : undefined
      }
      useFitHeight
    >
      <TableTemplate<Group>
        headers={tableHeaders}
        data={groups ?? []}
        fetchDataFunction={fetchGroups}
        editable={canEdit}
        onEdit={handleEdit}
        stickyHeader
        defaultEmptyText={
          groups ? "登録されたグループはありません" : "データ取得中"
        }
      />
    </MainTemplate>
  );
};
